import { elements } from 'weacast-core'

// Similar to core elements
export default elements.hooks
